import { render, staticRenderFns } from "./JDHome.vue?vue&type=template&id=4e98a5f0&scoped=true&"
import script from "./JDHome.vue?vue&type=script&lang=js&"
export * from "./JDHome.vue?vue&type=script&lang=js&"
import style0 from "./JDHome.vue?vue&type=style&index=0&id=4e98a5f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e98a5f0",
  null
  
)

export default component.exports